module.exports = __webpack_public_path__ + "img/banner-sport.31196aef.jpg";